import { getTaskOrderId } from "./TaskOrderUtilities";
/**
 * Task-order override for one My Tasks pivot/group pair.
 */ export class TaskOrder {
    forSerialization() {
        return {
            id: this.id,
            pivotType: this.pivotType,
            groupId: this.groupId,
            taskIds: [
                ...this.taskIds
            ]
        };
    }
    static fromPersistedResource(resource) {
        return new TaskOrder({
            pivotType: resource.pivotType,
            groupId: resource.groupId,
            taskIds: resource.taskIds ?? []
        });
    }
    constructor(properties){
        this.pivotType = properties.pivotType;
        this.groupId = properties.groupId;
        this.taskIds = [
            ...properties.taskIds
        ];
        this.id = getTaskOrderId(properties.pivotType, properties.groupId);
    }
}
